// removed by extract-text-webpack-plugin
module.exports = {"contain":"G7e9fba Gce3e1d"};